import React from 'react';
export default function ContactPhone({ value }) {
    if (!value) return '—';
    const parts = String(value).split(/\s*(?:·|;|\n|\s\/\s)\s*/).filter(Boolean);
    return <>{parts.map((part, index) => {
        const match = part.match(/^(?:(?:Tel|Cel):\s*)?([+\d][\d\s().-]*)(?:\s*(?:ext\.?|x)\s*(\d+))?$/i);
        const number = match?.[1].replace(/[^+\d]/g, '');
        const href = number && /^\+?\d{7,15}$/.test(number) ? `tel:${number}${match[2] ? `;ext=${match[2]}` : ''}` : null;
        return <React.Fragment key={index}>{index > 0 && ' · '}{href ? <a href={href}>{part}</a> : <span>{part}</span>}</React.Fragment>;
    })}</>;
}
